function getImagesByContext(context) {
    switch (typeof context) {
        case 'string':
            return jQuery(context).find('img');
        case 'object':
            return context.find('img');
        default:
            return jQuery('body').find('img');
    }
}

export function allImagesLoaded(callback, context) {
    const $images = getImagesByContext(context);
    const totalImages = $images.length;
    let imagesLoaded = 0;
    
    if (!totalImages) {
        callback($images);
        return;
    }
    
    $images.each(function(index, img) {
        jQuery('<img>')
            .on('load', function() {
                imagesLoaded++;
            
                if (imagesLoaded === totalImages) {
                    callback($images);
                }                  
            })
            .attr('src', jQuery(img).attr('src'));
    });
}